import React, { useMemo } from 'react';
import PageShell from '../../components/PageShell';
import { useP } from '../../i18n/useP';
import { usePersistentValue } from '../../hooks/usePersistentState';
import CashMovesPage from './CashMovesPage';
import SpecialEntriesCard from './SpecialEntriesCard';
import './CashMoves.css';

/* OPÉRATIONS SPÉCIALES (décision Olivier, 2026-10-20) : ce que le plan ne
   déduit d'aucune règle. Deux cartes dessous l'une de l'autre : ce qui passe
   par la liquidité (encaissement ou décaissement, contrepartie facultative),
   puis ce qui n'y passe pas (débit et crédit). La première reste aussi un
   détail du Plan de liquidité. */
export default function SpecialOperationsPage({ activeTenant, year, canWrite = true }) {
  const p = useP();
  const tid = activeTenant?.id;
  const [unit, setUnit] = usePersistentValue(`fc_steps_unit_${tid}`, 'kchf');
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);
  return (
    <PageShell kind="entry" title={p('Opérations spéciales')} unit={pageUnit}>
      <div className="cmv">
        <CashMovesPage activeTenant={activeTenant} year={year} unit={unit} canWrite={canWrite} />
        <SpecialEntriesCard activeTenant={activeTenant} year={year} unit={unit} canWrite={canWrite} />
      </div>
    </PageShell>
  );
}
